module.exports = __webpack_public_path__ + "static/media/canhemon_medium.63a3ff2b.jpg";